module.exports = {"id":"234153","name":"Carlos Soler","rating":"78","photo":"./data/images/photos/2/234153.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["MD","MC","MOC","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosSoler0.json
// module id = 727
// module chunks = 0